import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import Icon from "./icon";
import Button from "./button";

const PageHeader = ({ image, title, subtitle, breadcrumbs = [], actions, onBackClick, className }) => {
  //Needs this to handle a small css margin tweak for the back button
  const hasBreadCrumbsAndImage = breadcrumbs.length > 0 && image;

  return (
    <div className={classNames("et--page-header", className)}>
      <div className="et--page-header-content-wrap">
        {onBackClick && (
          <Button
            className={classNames("et--page-header--back", { "with-image-crumbs": hasBreadCrumbsAndImage })}
            type="simple"
            onClick={onBackClick}
            title="Go back"
          >
            <Icon icon="chevron-left" size={2} />
          </Button>
        )}
        <div>
          {breadcrumbs.length > 0 && (
            <div className="et--page-header-breadcrumbs">
              {breadcrumbs.map((crumb, index) => (
                <Fragment key={crumb}>
                  {crumb}
                  {(index === 0 && breadcrumbs.length !== 1) || index !== breadcrumbs.length - 1 ? (
                    <span className="et--page-header-breadcrumbs-separator">{`>`}</span>
                  ) : null}
                </Fragment>
              ))}
            </div>
          )}
          <div className="et--page-header-title-content">
            {image && <div className="et--page-header--image">{image}</div>}
            <div>
              <h1 tabIndex={-1}>{title}</h1>
              {subtitle && <div className="et--page-header--subtitle">{subtitle}</div>}
            </div>
          </div>
        </div>
      </div>
      {actions && <div className="et--page-header--actions">{actions}</div>}
    </div>
  );
};

PageHeader.propTypes = {
  image: PropTypes.any,
  title: PropTypes.any,
  subtitle: PropTypes.node,
  breadcrumbs: PropTypes.array,
  actions: PropTypes.node,
  onBackClick: PropTypes.func,
  className: PropTypes.string,
};

export default PageHeader;
